import { fetchApi } from '@/lib/api';
import { factoryInit, queryString, type FactoryRequestOptions } from '@/lib/factory-request';
import type { TaskDevServers } from '@shared/types/factory';

/**
 * SF-T-209: tasks' worktrees and their dev servers (/api/dev-servers), read from the machines' latest reports.
 * Start is for Members (a tidied worktree is made again from its branch); Stop and Tidy for Maintainers.
 */

/** With `taskId`, that task's newest worktree (gone or not); without, every task's worktree its machine still has. */
export function listDevServers(taskId: string | null = null, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ dev_servers: TaskDevServers[] }>(`/dev-servers${queryString({ task_id: taskId })}`, factoryInit(opts));
}

export function startDevServers(taskId: string, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ dev_servers: TaskDevServers }>('/dev-servers/start', factoryInit(opts, 'POST', { task_id: taskId }));
}

export function stopDevServers(taskId: string, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ dev_servers: TaskDevServers }>('/dev-servers/stop', factoryInit(opts, 'POST', { task_id: taskId }));
}

/** Refused (409 RUN_ACTIVE) while a run works in it; the machine refuses uncommitted or unpushed work. */
export function tidyWorktree(taskId: string, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ dev_servers: TaskDevServers }>('/dev-servers/tidy', factoryInit(opts, 'POST', { task_id: taskId }));
}

/** The task's own idle time in minutes, or null for the project's. */
export function setTaskDevIdle(taskId: string, minutes: number | null, opts: FactoryRequestOptions = {}) {
  return fetchApi<{ minutes: number | null }>('/dev-servers/idle', factoryInit(opts, 'PUT', { task_id: taskId, minutes }));
}
